<!--
  运营商套餐
  jay 2020-1-16
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="gradient"
      :title="$t('common.operatorPackage')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
    </van-nav-bar>

    <div class="scroll-wrapper">
      <div class="bg"></div>
      <div class="combo-content">
        <ul class="top-nav">
          <li
            :class="{ active: topActive == index }"
            v-for="(item, index) in topNav"
            :key="index"
            @click="changeTop(index)"
          >
            <h3>{{ item.title }}</h3>
            <p>{{ item.day }}</p>
          </li>
        </ul>
        <ul class="smart-tab">
          <li
            :class="{ active: smallTab == index }"
            v-for="(item, index) in comboList"
            :key="index"
            @click="changeSmart(index)"
          >
            <a>{{ item.name }}</a>
          </li>
        </ul>
        <div class="combo-list">
          <scroll ref="scroll" v-if="comboList.length">
            <ul>
              <li
                v-for="(item, index) in comboList[smallTab].list"
                :key="index"
              >
                <h3>
                  <span>{{ item.name }}</span>
                  <a @click="textOrCall(item)">
                    {{ $t("combo.selectAndSend") }}
                  </a>
                </h3>
                <p>{{ item.content }}</p>
              </li>
            </ul>
          </scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "combo",
  data() {
    return {
      topNav: [
        {
          title: this.$t("combo.shortStay"),
          day: "1-7" + this.$t("common.days")
        },
        {
          title: this.$t("combo.restAndStay"),
          day: "7-15" + this.$t("common.days")
        },
        {
          title: this.$t("combo.longStay"),
          day: this.$t("combo.30Days")
        }
      ],
      topActive: 0,
      smallTabArr: ["Globe", "Smart", "Sun"],
      smallTab: 0,
      comboList: []
    };
  },
  components: {},
  created() {
    this._getComboList();
  },
  mounted() {},
  computed: {},
  methods: {
    textOrCall(obj) {
      //发送短信
      //用户的电话号码
      let phone = obj.phone;
      //发送短信的内容
      let name = obj.message;
      let u = navigator.userAgent;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
      let isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1; //ios终端
      let sendcontent = "sms:" + phone + (isiOS ? "&" : "?") + "body=" + name;
      console.log("textOrCall", sendcontent);
      let newObj = {};
      newObj.type = "sms";
      newObj.phone = obj.phone;
      newObj.content = obj.message;
      window.location.href = sendcontent;
    },
    changeSmart(index) {
      //修改运营商
      let vm = this;
      vm.smallTab = index;
      vm.$refs.scroll.scrollTo(0, 0, 100);
    },
    changeTop(index) {
      //修改头部菜单
      let vm = this;
      vm.topActive = index;
      vm._getComboList();
    },
    _getComboList() {
      //获取运营商套餐
      let vm = this;
      let params = {};
      params.type = vm.topActive + 1;
      vm.$post("/app/help/productOperators", params, {
        loading: true
      }).then(res => {
        console.log("productOperators", res);
        vm.comboList = res.list;
        console.log("comboList", vm.comboList);
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.combo-content {
  background: #fff;
  border-radius: 8px;
  position: absolute;
  left: 16px;
  top: 16px;
  right: 16px;
  bottom: 16px;
  .top-nav {
    padding: 7px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1.1px solid #e4e4e4;
    li {
      width: 105px;
      height: 64px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #fff;
      font-size: 14px;
      line-height: 1.5;
      font-weight: 600;
      &:nth-child(1) {
        background: url("~@/assets/images/combo/pic_01_nor.png") no-repeat
          center;
        background-size: 100%;
      }
      &:nth-child(2) {
        background: url("~@/assets/images/combo/pic_02_nor.png") no-repeat
          center;
        background-size: 100%;
      }
      &:nth-child(3) {
        background: url("~@/assets/images/combo/pic_03_nor.png") no-repeat
          center;
        background-size: 100%;
      }
      &.active:nth-child(1) {
        background: url("~@/assets/images/combo/pic_01_sel.png") no-repeat
          center;
        background-size: 100%;
      }
      &.active:nth-child(2) {
        background: url("~@/assets/images/combo/pic_02_sel.png") no-repeat
          center;
        background-size: 100%;
      }
      &.active:nth-child(3) {
        background: url("~@/assets/images/combo/pic_03_sel.png") no-repeat
          center;
        background-size: 100%;
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
      p {
        font-size: 10px;
      }
    }
  }
  .smart-tab {
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1.1px solid #e4e4e4;
    li {
      padding: 0 12px;
      margin: 0 12px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      border-radius: 5px;
      a {
        font-size: 14px;
        color: #9b9b9b;
      }
      &.active {
        a {
          color: #fff;
        }
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
      }
    }
  }
  .combo-list {
    height: calc(100% - 90px - 42px);
    background: url("~@/assets/images/combo/pic_eepay.png") no-repeat right
      bottom;
    background-size: 270px;
    position: relative;
    ul {
      padding: 12px;
      li {
        h3 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fe7800;
          font-weight: 500;
          font-size: 14px;
          a {
            margin-left: 4px;
            padding: 0 4px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            font-size: 10px;
            color: #fff;
            background: #2042ab;
            border-radius: 3px;
          }
        }
        p {
          font-size: 12px;
          color: #4a4a4a;
          margin-top: 4px;
          line-height: 1.5;
          text-align: justify;
        }
      }
      li + li {
        margin-top: 12px;
      }
    }
  }
}
</style>
